import {Cart, ICartPosition} from "../../../typescript-library";
import * as React from "react";
import {useCartContext} from "../CartContextProvider/CartContextProvider";
import ItemRow from "./ItemRow";
import {getShopId} from "../../lib/getShopId";
import {useCheckoutContext} from "../../checkout/CheckoutContextProvider/CheckoutContextProvider";
import styles from "./ItemList.module.scss";
import summaryStyles from "../../checkout/steps/Summary/Summary.module.scss";
import {useTranslation} from "react-i18next";

type ItemListSummaryType = {goToCartView?: () => void};
type ItemListType = ItemListSummaryType & {cart: Cart; editable?: true | undefined; goToCartView?: () => void};

const ItemList: React.FC<ItemListType> = (props) => {
  const itemPositions = props.cart.positions.filter((pos) => pos.reference && pos.reference.itemId !== null);
  const {t} = useTranslation();

  if (!itemPositions.length) {
    return null;
  }

  const fixVouchers = props.cart.positions.filter<ICartPosition>(
    (pos: ICartPosition): pos is ICartPosition => pos.type === "Voucher" && pos.reference?.voucher?.type === "Fix",
  );

  const relativeVouchers = props.cart.positions.filter<ICartPosition>(
    (pos: ICartPosition): pos is ICartPosition => pos.type === "Voucher" && pos.reference?.voucher?.type === "Relative",
  );

  return (
    <React.Fragment>
      {props.goToCartView && (
        <button type="button" className={summaryStyles.pen} onClick={props.goToCartView}>
          <span className="icon icon-pencil--blue icon-size--20">&#160;</span>
          <span className="visually-hidden">{t("checkout.editCart")}</span>
        </button>
      )}
      <div>
        <ul className={`${styles.itemList} ArrowBorder list-style-none`}>
          {itemPositions.map((position) => (
            <li key={`ItemRow${position.item ? position.item.itemId : position.text}`}>
              <ItemRow
                editable={!!props.editable}
                fixVouchers={fixVouchers}
                position={position}
                relativeVouchers={relativeVouchers}
              />
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

export const ItemListSummary: React.FC<ItemListSummaryType> = ({goToCartView}) => {
  const {checkout} = useCheckoutContext();
  const dummyCart = new Cart(getShopId(), checkout.cartData);

  return <ItemList cart={dummyCart} goToCartView={goToCartView} />;
};

const ItemListCart: React.FC = () => {
  const {cart} = useCartContext();

  return <ItemList cart={cart} editable />;
};

export default ItemListCart;
